// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__-s7wo","info":"Hero_info__HKZhn","hero":"Hero_hero__zvVCj"};